import { Box, LinearProgress, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { Content, ContentStepper } from '../../components'
import { Props } from './types'

const steps = ['Início', 'Sobre', 'Tecnologias', 'Projetos', 'Contato']

const Index = ({ toggleDarkMode, isMobileDevice }: Props) => {
  const [activeStep, setActiveStep] = useState(0)
  const theme = useTheme()

  return (
    <Box
      component="main"
      width="100vw"
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box
        display="flex"
        flexDirection={isMobileDevice ? 'column' : 'row'}
        justifyContent={isMobileDevice ? 'space-between' : 'space-around'}
        height="98.5%"
        width={'100%'}
      >
        <Content currentStep={activeStep} isMobileDevice={isMobileDevice} />
        <ContentStepper
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          steps={steps}
          isMobileDevice={isMobileDevice}
          theme={theme}
          toggleDarkMode={toggleDarkMode}
        />
      </Box>
      {!isMobileDevice && (
        <LinearProgress
          variant="determinate"
          value={activeStep ? ((activeStep + 1) / steps.length) * 100 : 0}
          style={{
            height: '1.5%',
          }}
        />
      )}
    </Box>
  )
}

export default Index
